<template>DRC {{ DRC }}</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    DRC() {
      let drc = {
        "0": this.$e("Déconnecté"),
        "1": this.$e("En cours d'activation"),
        "2": this.$e("Activé"),
      };

      return this.config?.dock?.status?.drc_state != undefined
        ? drc[this.config.dock.status.drc_state]
        : ENV.NO_DATA;
    },
  },
};
</script>
